import { render, staticRenderFns } from "./top-aside.vue?vue&type=template&id=dded0afa&scoped=true&"
import script from "./top-aside.vue?vue&type=script&lang=js&"
export * from "./top-aside.vue?vue&type=script&lang=js&"
import style0 from "./top-aside.vue?vue&type=style&index=0&id=dded0afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dded0afa",
  null
  
)

export default component.exports